import { Map } from 'immutable';

import * as types from './types';

const initialState = new Map({
  initialized: false,
  data: new Map(),
});

export default function entitlementsReducer(state = initialState, { type, payload }) {
  switch (type) {
    case types.LOAD_ORG_ENTITLEMENTS.FAILURE:
      return state.set('initialized', true);

    case types.LOAD_ORG_ENTITLEMENTS.SUCCESS: {
      const entitlements = payload.entitlements.reduce((acc, entitlement) => (
        acc.set(entitlement.name, entitlement.value)
      ), new Map());
      return state
        .set('initialized', true)
        .set('data', entitlements);
    }

    default:
      return state;
  }
}
